// @flow

import { localStorage } from '../../kodyl/web-storage';
import config from '../config';

export default async function graph(query, variables) {
  const token = localStorage.getItem(config.ls_token);

  if (!token) {
    throw new Error('Graph requests require a valid auth token');
  }

  const headers = {
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };

  const response = await fetch('/api/graph', {
    headers,
    method: 'post',
    body: JSON.stringify({ query, variables }),
    credentials: 'include'
  });

  if (response.status >= 200 && response.status < 300) {
    return await response.json();
  }

  // TODO: Handle errors

  return await response.json();
}
